import Api from '../../api'

const Driver = {
  namespaced: true,
  state: {
    oneDriver: null,
    allDrivers: null,
    errorMessagem: null,
    errorActive: null,
    updateConfirmation: null,
    updateMessage: null,

    allDeliveries: null,
    oneDelivery: null,
  },
  mutations:{
    setDriver(state, driver){
      state.oneDriver = {...driver}
    },
    getDrivers(state, drivers){
      state.allDrivers = drivers.data;
    },
    pushDriver(state, driver){
      state.allDrivers.push(driver);
    },
    getOneDriver(state, driver){
      state.oneDriver = driver;
    },
    updateStatus(state, {status, msg}){
      state.updateConfirmation = status
      state.updateMessage = msg
      setTimeout(() => {
        state.updateConfirmation = null
        state.updateMessage = null
      }, 500);
    },
    setErrorMessage(state, {message, status}){
      state.errorMessage = message;
      state.errorActive = status;
      setTimeout(() => {
        state.errorActive = null;
      }, 100);
    },
    getAllDeliveries(state, deliveries){
      state.allDeliveries = deliveries
    },
    getOneDelivery(state, delivery){
      state.oneDelivery = delivery.data.attributes
    },
    clearDeliveries(state){
      state.allDeliveries = null
      state.oneDelivery = null
    },
    clearDriver(state){
      state.oneDriver = null
    },
    clearAllDrivers(state){
      state.allDrivers = null
    },
    clearMsg(state){
      state.updateConfirmation = null
      state.updateMessage = null
    },
  },
  actions: {
    setDriver(context, driver){
      context.commit('setDriver', driver);
    },
    indexDeliveries(context, filter){
      return Api.Driver.indexDeliveries(filter)
        .then(response => response.data)
        .then(deliveries => {
          context.commit('getAllDeliveries', deliveries);
          return deliveries
          // context.commit('setErrorMessage', {message: '', status: false})
        }).catch(function(error) {
          console.log(error);
        });
    },
    index(context){
      return Api.Driver.index()
        .then(response => response.data)
        .then(drivers => {
          context.commit('getDrivers', drivers);
          // context.commit('setErrorMessage', {message: '', status: false})
          return drivers
        }).catch(function(error) {
          console.log(error);
        });
    },
    clearDeliveries(context){
      context.commit('clearDeliveries')
    },
    clearDriver(context){
      context.commit('clearDriver')
    },
    clearAllDrivers(context){
      context.commit('clearAllDrivers')
    },
    clearUpdateMessage(context){
      context.commit('clearMsg')
    },
  }
};

export default Driver;
